import React, {createContext, useCallback, useContext, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useNotification } from "./notificationContext";
import { axiosInstance } from "../services/axiosInstance";

const userContext = createContext();

const UserProvider = ({ children }) => {
  const [, , showNotification] = useNotification();
  const navigate = useNavigate();
  const [auth, setAuth] = useState({
    user: null,
    loading: false,
    isAuthenticated: false,
    error: null,
  });


  const fetchProfile = async () => {
    setAuth((prevState) => ({
      ...prevState,
      loading: true,
      isAuthenticated: false,
      error: null,
    }));

    await axiosInstance
      .get("/profile", {
        withCredentials: true,
      })
      .then((data) => {
        setAuth({
          user: data?.data?.user,
          loading: false,
          isAuthenticated: true,
          error: null,
        });
      })
      .catch((error) => {
        console.log("error", error.response.data.message);
        setAuth((prevState) => ({
          ...prevState,
          loading: false,
          error:
            error?.response?.data?.message === "Not Authorized, not token"
              ? null
              : error?.response?.data?.message,
        }));
      });
  };

  // Function to refetch the profile data
  const refetchProfile = () => {
    fetchProfile();
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  // LOGOUT HANDLER START
  const handleLogout = useCallback(async () => {
    setAuth((prev) => ({
      ...prev,
      loading: true,
    }));
    await axiosInstance
      .get("/logout")
      .then((data) => {
        if (data?.data?.success) {
          navigate("/");
          setAuth({
            user: null,
            loading: false,
            isAuthenticated: false,
            error: null,
          });
        }
      })
      .catch((err) => showNotification("error", err?.response?.data?.message));
  }, [navigate, showNotification]);
  // LOGOUT HANDLER ENDS

  useEffect(() => {
    if (auth.error) {
      showNotification("error", auth.error);
      setAuth((prevState) => ({
        ...prevState,
        loading: false,
        error: null,
      }));
      handleLogout();
    }
  }, [auth.error, showNotification, handleLogout]);

  return (
    <userContext.Provider value={{auth, setAuth, refetchProfile, handleLogout}}>
      {children}
    </userContext.Provider>
  );
};

const useAuth = () => useContext(userContext);

export { useAuth, UserProvider };
